<div class="absolute size-full bg-[url(/background.png)] bg-cover bg-center"></div>
